<template>
    <div class="modal fade" tabindex="-1" role="dialog" v-el:modal>
        <div class="modal-dialog" :style="modalWidth">
            <div class="modal-content">
                <!-- Header 部分 -->
                <slot name="header">
                    <div class="modal-header" v-if="!!title">
                        <button type="button"
                                class="close" data-dismiss="modal"
                                aria-label="Close"
                                v-if="closable">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title" v-if="!!title" v-text="title"></h4>
                    </div>
                </slot>
                <!-- Body 部分 -->
                <div class="modal-body">
                    <slot>
                        {{content}}
                    </slot>
                </div>
                <!-- Footer 部分 -->
                <slot name="footer">
                    <div class="modal-footer" v-if="!noFooter">
                        <button type="button"
                                class="btn btn-default"
                                data-dismiss="modal"
                                @click='cancelClicked'
                                v-text="cancelText">{{cancelText}}
                        </button>
                        <button type="button"
                                class="btn"
                                :class="['btn-'+theme, loading ? 'disabled' : '']"
                                @click='okClicked'
                                v-text="okText"
                                v-if="!noOk"
                        >
                        </button>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script lang="babel">
    /**
     * Created by Pan on 16/5/4.
     * 模态
     */
    import _ from 'lodash'
    // bootstrap js
    // import 'bootstrap/js/modal'
    export default{
        props: {

            /**
             * 对话框是否可见
             */
            visible: {
                type: Boolean,
                twoWay: true
            },

            /**
             * 主题
             */
            theme: {
                type: String,
                default: 'primary',
                coerce(val) {
                    return _.includes([ 'info', 'primary', 'success', 'danger', 'warning' ], val) ? val : 'primary'
                }
            },

            /**
             * 标题
             */
            title: {
                type: String,
                default: ''
            },

            /**
             * 文本内容
             */
            content: {
                type: String,
                default: ''
            },

            /**
             * 是否显示右上角的关闭按钮
             */
            closable: {
                type: Boolean,
                default: true
            },

            /**
             * 模态宽度
             */
            width: {
                type: [ Number, String ]
            },

            /**
             * 隐藏默认的 footer
             */
            noFooter: Boolean,

            /**
             * 取消按钮文字
             */
            cancelText: {
                type: String,
                default: '取消'
            },

            /**
             * 去掉确认按钮
             */
            noOk: Boolean,

            /**
             * 确认按钮文字
             */
            okText: {
                type: String,
                default: '确定'
            },

            /**
             * 模态背景
             * true: 点击背景关闭模态
             * 'static': 点击背景不关闭模态
             */
            backdrop: {
                type: [ Boolean, String ]
            },

            /**
             * 确定按钮是否正在加载
             */
            loading: false
        },
        computed: {
            modalWidth() {
                return this.width ? { width: this.width + 'px' } : {}
            }
        },
        watch: {
            visible(val) {
                $(this.$els.modal).modal(val ? 'show' : 'hide')
            }
        },
        ready() {
            $(this.$els.modal).modal({
                backdrop: this.backdrop,
                show: false
            }).on('hide.bs.modal', () => {
                this.visible = false
                document.body.style.paddingRight = 0
            }).on('show.bs.modal', () => {
                this.$dispatch('show')
            }).on('shown.bs.modal', () => {
                this.$dispatch('shown')
            })
            this.$nextTick(function () {
                $(this.$els.modal).appendTo('body')
            })
        },
        methods: {
            /**
             * 取消按钮点击事件
             */
            cancelClicked() {
                this.$dispatch('cancel')
            },
            /**
             * 确定按钮点击事件
             */
            okClicked() {
                this.$dispatch('ok')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// index.vue?4620a95c